module.exports = __webpack_public_path__ + "media/assets/img/flags/qu-BO-248952728eb7f89221d3675b4527116e.png";